import { useGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useGuttagekonto';
import {
  calculateSumDauer,
  calculateSumFaktor,
} from '@/domain/mitarbeiter/features/guttagekonto/utils/calculateSum';
import { formatMinutes } from '@/domain/mitarbeiter/features/guttagekonto/utils/formatMinutes';
import { formatNumberToString } from '@/domain/mitarbeiter/features/guttagekonto/utils/formatNumberToString';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Badge,
  Body,
  Button,
  Card,
  DataDisplayProminent,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  TableRow,
  Table,
  TableBody,
  TableCell,
  Title,
} from '@e2n/ui/v2';
import { faMessageLines, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function AbwesenheitenAccordion() {
  const { id } = useParams();
  const currentYear = dayjs().year();
  const { guttagekonto } = useGuttagekonto([id ?? ''], currentYear);
  const abwesenheiten = guttagekonto.abwesenheiten;
  const { t } = useTranslation();

  let totalSumOfFaktor =
    calculateSumFaktor({ abwesenheiten: abwesenheiten }) ?? 0;
  let totalSumOfDauer =
    calculateSumDauer({ abwesenheiten: abwesenheiten }) ?? 0;

  return (
    <>
      <Card>
        {guttagekonto.abwesenheiten && (
          <>
            <Accordion type="multiple">
              {guttagekonto.abwesenheiten.map((abwesenheit, index) => (
                <AccordionItem value={abwesenheit.uid}>
                  <AccordionTrigger>
                    {dayjs(abwesenheit.datum).format('dd., DD.MM.')}
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex row flex-wrap gap-8">
                      <DataDisplayProminent
                        className="basis-1/2"
                        key={index}
                        label="Art"
                        showLeadingIcon={false}
                        showDot={false}
                        size="sm"
                        state="default"
                        value1={
                          <Badge
                            layout="character"
                            size="md"
                            icon={
                              <FontAwesomeIcon
                                color={abwesenheit.grund.markierung}
                                icon={abwesenheit.abwesenheitsgrundIcon}
                              />
                            }>
                            {abwesenheit.grund.value}
                          </Badge>
                        }
                        variant="data"
                      />
                      <DataDisplayProminent
                        className="basis-1/4"
                        key={index}
                        label="Tage"
                        showLeadingIcon={false}
                        showDot={false}
                        size="sm"
                        state="default"
                        value1={formatNumberToString(abwesenheit.faktor)}
                        variant="data"
                      />

                      <DataDisplayProminent
                        className="basis-1/2"
                        key={index}
                        label="Dauer"
                        showLeadingIcon={false}
                        showDot={false}
                        size="sm"
                        state="default"
                        value1={formatMinutes(abwesenheit.dauer)}
                        variant="data"
                      />
                    </div>
                    <div className="flex row pt-4 gap-2">
                      {abwesenheit.bemerkung && (
                        <Drawer>
                          <DrawerTrigger asChild>
                            <Button variant="ghost" iconOnly aria-label="Info">
                              <FontAwesomeIcon icon={faMessageLines} />
                            </Button>
                          </DrawerTrigger>
                          <DrawerContent>
                            <DrawerHeader>
                              <DrawerTitle>
                                <Title>
                                  {t(
                                    'domain.mitarbeiter.guttagekonto.bemerkung',
                                  )}
                                </Title>
                              </DrawerTitle>
                            </DrawerHeader>
                            <DrawerBody>
                              <Body>{abwesenheit.bemerkung}</Body>
                            </DrawerBody>
                          </DrawerContent>
                        </Drawer>
                      )}
                      <Button
                        variant="secondary-red-on-grey"
                        iconOnly
                        aria-label="Hinzufügen">
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
              <Table>
                <TableBody>
                  <TableRow className="border-none justify-items-stretch">
                    <TableCell
                      type="text"
                      text="Gesamt"
                      showBottomLine={false}
                    />
                    <TableCell
                      type="text"
                      text={formatNumberToString(totalSumOfFaktor)}
                      showBottomLine={false}
                    />
                    <TableCell
                      type="text"
                      text={formatMinutes(totalSumOfDauer)}
                      showBottomLine={false}
                    />
                  </TableRow>
                </TableBody>
              </Table>
            </Accordion>
          </>
        )}
      </Card>
    </>
  );
}
